module.exports = __webpack_public_path__ + "static/media/submit.c368f509.webp";